import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "children", "onChange", "checked", "disabled", "indeterminate", "uncheckable", "noCheckbox"];
import PropTypes from 'prop-types';
import React from 'react';
import Checkbox from '../Checkbox';
import DropdownControlOption from '../DropdownControlOption';
import { canTouch } from '../tools/touch'; // 下拉菜单多选选项

export default function DropdownCheckboxOption(_ref) {
  var className = _ref.className,
      children = _ref.children,
      onChange = _ref.onChange,
      checked = _ref.checked,
      disabled = _ref.disabled,
      indeterminate = _ref.indeterminate,
      uncheckable = _ref.uncheckable,
      noCheckbox = _ref.noCheckbox,
      other = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(DropdownControlOption, _extends({
    className: className,
    selected: checked,
    disabled: disabled,
    onClickBack: function onClickBack() {
      if (!canTouch) {
        onChange(!checked);
      }
    },
    control: !noCheckbox && /*#__PURE__*/React.createElement(Checkbox, {
      className: "jmtd-dropdown-checkbox-option-checkbox",
      uncheckable: uncheckable,
      disabled: disabled,
      checked: checked,
      onChange: onChange,
      indeterminate: indeterminate
    })
  }, other), children);
}
DropdownCheckboxOption.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  size: PropTypes.oneOf(['large', 'middle', 'small', 'mini']),
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  showArrow: PropTypes.bool,
  disabled: PropTypes.bool,
  expanded: PropTypes.bool,
  indeterminate: PropTypes.bool,
  uncheckable: PropTypes.bool,
  noCheckbox: PropTypes.bool
};
DropdownCheckboxOption.defaultProps = {
  className: '',
  children: null,
  size: null,
  onChange: function onChange() {},
  checked: false,
  showArrow: false,
  disabled: false,
  expanded: false,
  indeterminate: false,
  uncheckable: false,
  noCheckbox: false
};